var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHmSupportersIcon = function SvgHmSupportersIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4C5158",
    d: "M15 13h-1V7.222a1 1 0 0 0-.323-.736l-5-4.717-.007-.007a1 1 0 0 0-1.346 0l-.006.007-4.995 4.717A1 1 0 0 0 2 7.222V13H1a.5.5 0 0 0 0 1h14a.5.5 0 0 0 0-1M3 7.222l.007-.006L8 2.5l4.994 4.715.007.006v5.78H10v-3a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v3H3zM9 13H7v-3h2z"
  })));
};
export default SvgHmSupportersIcon;